(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "69209e08fbc50a8d060f52d2";
              window.beaePageSetting.pageTitle = "Countdown - Beae"; 
              window.beaePageSetting.pageType = "section";

          let js_MP7N40F7 = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-h1fyn01msection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-h1fyn01m',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-h1fyn01m');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-h1fyn01m: ', ex)
      };
    

      try {
        let argid = 'beae-mv2p9ke7block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-mv2p9ke7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-mv2p9ke7');
        args.el = args.els[0];
        ((P) => { var z;let H=(z=P.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(R=>{let O=R==null?void 0:R.getAttribute("href");R&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&R.addEventListener("click",I=>{let A=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),I.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-mv2p9ke7: ', ex)
      };
    

      try {
        let argid = 'beae-cmlogwrbblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-cmlogwrb',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-cmlogwrb');
        args.el = args.els[0];
        ((P) => { var z;let H=(z=P.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(R=>{let O=R==null?void 0:R.getAttribute("href");R&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&R.addEventListener("click",I=>{let A=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),I.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-cmlogwrb: ', ex)
      };
    

      try {
        let argid = 'beae-ymta5ir3block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ymta5ir3',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ymta5ir3');
        args.el = args.els[0];
        ((P) => { var z;let H=(z=P.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(R=>{let O=R==null?void 0:R.getAttribute("href");R&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&R.addEventListener("click",I=>{let A=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),I.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ymta5ir3: ', ex)
      };
    

      try {
        let argid = 'beae-nau8uir1block-countdown',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-nau8uir1',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-nau8uir1');
        args.el = args.els[0];
        ((C) => { C.mode.value=="builder"&&window.BeaeRunCountdown&&window.BeaeRunCountdown(C) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-nau8uir1: ', ex)
      };
    }; if (window.BEAEBASE) {js_MP7N40F7()} else {window.BEAEPAGEJS.push(js_MP7N40F7)} })(); 